// @flow
import { error } from './common';
import * as types from '../types/gates';
import type { ID_TYPE } from '../types/common';
import type {
  GATE_TYPE,
  GATES_FETCH_SUCCESS_TYPE,
  GATES_FETCH_STARTED_TYPE,
  GATE_FETCH_SUCCESS_TYPE,
  GATE_CREATE_STARTED_TYPE,
  GATE_CREATE_SUCCESS_TYPE,
  REMOVE_GATE_STARTED_TYPE,
  REMOVE_GATE_SUCCEED_TYPE,
  GATE_SELECTED_TYPE,
} from '../types/gates';


export const startFetchingGates = (schoolId: number): GATES_FETCH_STARTED_TYPE => ({
  type: types.GATES_FETCH_STARTED,
  payload: schoolId,
});

export const gatesFetchSucceed = (
  entities: {[number]: GATE_TYPE},
  order: Array<number>,
): GATES_FETCH_SUCCESS_TYPE => ({
  type: types.GATES_FETCH_SUCCESS,
  payload: {
    entities,
    order,
  },
});


export const gateFetchSucceed = (
  gate: GATE_TYPE,
): GATE_FETCH_SUCCESS_TYPE => ({
  type: types.GATE_FETCH_SUCCESS,
  payload: gate,
});

export const gateCreateStarted = (
  gate: GATE_TYPE,
): GATE_CREATE_STARTED_TYPE => ({
  type: types.GATE_CREATE_STARTED,
  payload: gate,
});

export const gateCreateSuccess = (
  gate: GATE_TYPE,
): GATE_CREATE_SUCCESS_TYPE => ({
  type: types.GATE_CREATE_SUCCESS,
  payload: gate,
});

export const removeGateStart = (id: number): REMOVE_GATE_STARTED_TYPE => ({
  type: types.REMOVE_GATE_STARTED,
  payload: id,
});

export const removeGateSuccess = (id: number): REMOVE_GATE_SUCCEED_TYPE => ({
  type: types.REMOVE_GATE_SUCCEED,
  payload: id,
});

export const removeGateFailed = error(types.REMOVE_GATE_FAILED);

export const selectGate = (
  payload: ID_TYPE,
): GATE_SELECTED_TYPE => ({
  type: types.GATE_SELECTED,
  payload,
});

export const gateCreateFailed = error(types.GATE_CREATE_FAILED);
export const gateFetchFailed = error(types.GATES_FETCH_FAILED);



// WEBPACK FOOTER //
// ./src/scripts/actions/gates.js